import { apis } from '../../../config';
import { api } from '../../../api/api';
class EmptyApiImpl {
    constructor() {
        this.name = apis.emptyApiImpl;
    }
    init() {
        return this.name;
    }
}
const emptyApi = new EmptyApiImpl();
api.registerLogicalApi(emptyApi);
export default emptyApi;
